import { cn } from '@src/design-system/helpers';

import type { ComponentProps } from 'react';
import { EditableCell } from './editable-cell';
import {
  TiclickDatePicker,
  TiclickDatePickerCalendarPopover,
  TiclickDatePickerCalendarPopoverTrigger,
} from '@src/design-system/ticlick-date-picker';
import { Calendar } from 'iconsax-react';

export function EditableDateCell({
  children,
  ...props
}: ComponentProps<typeof TiclickDatePicker>) {
  return (
    <TiclickDatePicker {...props}>
      <EditableCell>{children}</EditableCell>
    </TiclickDatePicker>
  );
}

export function EditableDateCellEditMode({
  ...props
}: ComponentProps<typeof TiclickDatePickerCalendarPopover>) {
  return (
    <TiclickDatePickerCalendarPopover
      align='start'
      alignOffset={-8}
      closeOnSelect
      {...props}
    />
  );
}

export function EditableDateCellViewMode({
  className,
  children,
  ...props
}: ComponentProps<typeof TiclickDatePickerCalendarPopoverTrigger>) {
  return (
    <TiclickDatePickerCalendarPopoverTrigger
      className={cn(
        'truncate items-start text-start w-full h-full cursor-pointer',
        className
      )}
      {...props}
    >
      {children}
      <Calendar
        size={16}
        className='text-primary-1000 absolute right-4 top-1/2 -translate-y-1/2 group-hover:block hidden'
      />
    </TiclickDatePickerCalendarPopoverTrigger>
  );
}
